import { MESSAGE_TYPE } from "./enums.js"
import useUserStore from '../store/userStore.js';

let previewContent = function (msgInfo) {
    let content = "[暂不支持该消息类型]"
    try {
        // 插入新的数据
        if (msgInfo.type == MESSAGE_TYPE.IMAGE) {
            content = "[图片]";
        } else if (msgInfo.type == MESSAGE_TYPE.VIDEO) {
            content = "[视频]";
        } else if (msgInfo.type == MESSAGE_TYPE.FILE) {
            content = "[文件] " + JSON.parse(msgInfo.content).name;
        } else if (msgInfo.type == MESSAGE_TYPE.AUDIO) {
            content = "[语音] " + JSON.parse(msgInfo.content).duration + '"';
        } else if (msgInfo.type == MESSAGE_TYPE.USER_CARD) {
            content = "[个人名片] " + JSON.parse(msgInfo.content).nickName;
        } else if (msgInfo.type == MESSAGE_TYPE.GROUP_CARD) {
            content = "[群名片] " + JSON.parse(msgInfo.content).groupName;
        } else if (msgInfo.type == MESSAGE_TYPE.STICKER) {
            content = "[动画表情] " + JSON.parse(msgInfo.content).name;
        } else if (msgInfo.type == MESSAGE_TYPE.MERGE_FORWARD) {
            content = `[合并转发] 共${JSON.parse(msgInfo.content).messages.length}条消息`;
        } else if (msgInfo.type == MESSAGE_TYPE.ACT_RT_VOICE) {
            content = "[语音通话]";
        } else if (msgInfo.type == MESSAGE_TYPE.ACT_RT_VIDEO) {
            content = "[视频通话]";
        } else if (msgInfo.type == MESSAGE_TYPE.SYSTEM_MESSAGE) {
            content = msgInfo.title;
        } else if (msgInfo.type == MESSAGE_TYPE.TEXT ||
            msgInfo.type == MESSAGE_TYPE.RECALL) {
            content = msgInfo.content;
        } else if (msgInfo.type == MESSAGE_TYPE.TIP_TEXT) {
            // 将 #{displayName:userId} 格式转换为 displayName
            const userStore = useUserStore();
            content = msgInfo.content.replace(/#\{([^:]+):(\d+)\}/g, (match, displayName, userId) => {
                // 如果是当前登录用户，用"你"代替昵称
                if (userStore.userInfo.id == userId) {
                    return '你';
                }
                return displayName;
            });
        }
    } catch (e) {
        console.log("message:", msgInfo, e)
    }
    return content;
}

export {
    previewContent
}